export enum ThemeType {
    System = 'system',
    Light = 'light',
    Dark = 'dark',
    Nord = 'nord',
    SolarizedDark = 'solarizedDark',
}
